import { render } from "./STLPreview.vue?vue&type=template&id=0cb88924&scoped=true"
import script from "./STLPreview.vue?vue&type=script&lang=js"
export * from "./STLPreview.vue?vue&type=script&lang=js"

import "./STLPreview.vue?vue&type=style&index=0&id=0cb88924&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb88924"]])

export default __exports__